export default __webpack_public_path__ + "static/media/tempPic02.23e85ae0.jpeg";